var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "organization-admin-add-form__wrapper" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "organization-admin-add-form__content" },
      [
        _c("vue-form-generator", {
          attrs: {
            schema: _vm.schema,
            model: _vm.formModel,
            options: _vm.formOptions
          },
          on: { validated: _vm.onValidated }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "btn btn-default organization-admin-add-form__submit-button",
        attrs: { type: "button", disabled: _vm.hasErrors },
        on: { click: _vm.createUserAndLinkWithHospital }
      },
      [
        _c("span", { staticClass: "glyphicon glyphicon-plus" }),
        _vm._v(" Add\n  ")
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "organization-admin-add-form__header" }, [
      _c("h4", [_vm._v("Add new user")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13177822", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13177822","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationAdminAddForm/OrganizationAdminAddForm.vue
// module id = null
// module chunks = 